import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import '@ant-design/v5-patch-for-react-19';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import { WisecureProvider } from '@wisecure/api-client/hooks';
import axios from 'axios';
import { queryClient } from '@/api/client';
import { useAuthStore } from '@/stores';
import { AppRouter } from '@/router';
import { wisecureTheme } from '@/theme';
import '@/styles/global.css';

const getToken = async (): Promise<string> => useAuthStore.getState().token ?? '';

async function bootstrap() {
  const { isAuthenticated } = useAuthStore.getState();
  if (isAuthenticated) {
    try {
      const { data } = await axios.post<{
        accessToken: string;
        expiresIn: number;
      }>(`${import.meta.env.VITE_API_URL ?? ''}/api/auth/refresh`, {}, { withCredentials: true });
      const user = useAuthStore.getState().user;
      if (user) {
        useAuthStore.getState().login(data.accessToken, user);
      }
    } catch {
      useAuthStore.getState().logout();
    }
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <WisecureProvider baseUrl={import.meta.env.VITE_API_URL ?? ''} token={getToken}>
          <ConfigProvider locale={frFR} theme={wisecureTheme}>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </ConfigProvider>
        </WisecureProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

bootstrap();
